// Supabase browser client.
//
// Uses the publishable (anon) key only. The service role key NEVER appears
// in this codebase or in any browser bundle. Service role calls happen
// exclusively from Edge Functions.
//
// Environment variables required (set in .env.local for dev or in deployment env):
//   VITE_SUPABASE_URL - the Supabase project URL
//   VITE_SUPABASE_PUBLISHABLE_KEY - the publishable (anon) key
//
// Authentication uses magic link / OTP. See AuthContext for the four-state
// session model (loading, unauthenticated, unprovisioned, ready).

import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@shared/types/database";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl) {
  throw new Error(
    "VITE_SUPABASE_URL is not set. Add it to .env.local or your deployment environment."
  );
}

if (!supabasePublishableKey) {
  throw new Error(
    "VITE_SUPABASE_PUBLISHABLE_KEY is not set. Add it to .env.local or your deployment environment."
  );
}

// Single shared Supabase client for the browser application.
// Persists session in localStorage by default. Auto-refreshes tokens.
export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl,
  supabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
